import type { CreateGenerationInput, GenerationJob, GenerationJobList, RetryGenerationInput } from "@storyline/shared";
import { unwrap } from "@/src/common/services/api-error";
import { httpClient, request } from "@/src/common/services/http.service";

export const createGeneration = async (body: CreateGenerationInput): Promise<GenerationJob> =>
	unwrap(await request(() => httpClient.admin.generations.post(body)));

export const retryGeneration = async (jobId: string, body: RetryGenerationInput): Promise<GenerationJob> =>
	unwrap(await request(() => httpClient.admin.generations({ jobId }).retry.post(body)));

export const refreshGeneration = async (jobId: string): Promise<GenerationJob> =>
	unwrap(await request(() => httpClient.admin.generations({ jobId }).get()));

export const listSeriesGenerations = async (seriesId: string): Promise<GenerationJobList> =>
	unwrap(await request(() => httpClient.admin.series({ id: seriesId }).generations.get()));

export const listStoryGenerations = async (storyId: string): Promise<GenerationJobList> =>
	unwrap(await request(() => httpClient.admin.stories({ id: storyId }).generations.get()));
